var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "456FEAED-4B51-46DD-9C57-2750B6DED186") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.3913,7.873 L9.0953,10.992 L2.9463,13.042 L6.3913,7.873 Z M-1.01696429e-13,6.3965 L4.566,7.0055 L1.243,11.9915 L-1.01696429e-13,6.3965 Z M12.2883,5.7419 L10.1563,10.0059 L7.1543,6.2979 L12.2883,5.7419 Z M6.1094,-7.10542736e-14 L5.4284,5.103 L0.9584,4.507 L6.1094,-7.10542736e-14 Z M8.105,0.1651 L11.874,4.5621 L7.449,5.0831 L8.105,0.1651 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1896518,19.6532014 L23.9292329,26.3147552 C24.4972176,26.973579 24.0314904,28 23.1638205,28 L23.1638205,28 L7.13166893,28 C6.32272108,28 5.84079471,27.0937354 6.28931022,26.4165827 L6.28931022,26.4165827 L8.65236938,22.8505843 L18.1896518,19.6532014 Z M28.8691808,12.3646958 C29.5768836,12.2811973 30.1458807,12.9390028 29.966677,13.6324479 L29.966677,13.6324479 L27.1470027,24.5055863 C26.9414753,25.2978041 25.9361121,25.5340439 25.4025507,24.9149328 L25.4025507,24.9149328 L19.5708366,18.1474784 L22.0442529,13.1721877 Z M1.03270273,12.4208911 L1.14727731,12.4299672 L5.48056487,13.0103839 L7.29487593,21.2268433 L5.10899559,24.5250354 C4.63618127,25.2378278 3.55285937,25.0810134 3.29974678,24.2633388 L3.29974678,24.2633388 L0.0467437587,13.7415052 C-0.172957971,13.0307494 0.413250791,12.3311946 1.14727731,12.4299672 Z M16.5335868,0.884767435 C16.6388816,0.088476535 17.5784355,-0.277084121 18.1899556,0.240199481 L18.1899556,0.240199481 L28.1382928,8.67355145 C28.8166346,9.24785844 28.4845509,10.3587963 27.6037191,10.4626603 L27.6037191,10.4626603 L22.0514412,11.1204658 L16.1022829,4.140192 Z M12.7636266,0.798926869 C13.4814539,0.255168121 14.4959292,0.850858884 14.3774725,1.74694072 L14.3774725,1.74694072 L14.1051233,3.7967279 L5.9052878,11.0132415 L2.73024345,10.5865843 C1.83219998,10.4664279 1.53048977,9.31272254 2.25439178,8.7648907 L2.25439178,8.7648907 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-67.000000, -600.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(24.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Radar-Chart/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(12.433100, 12.649800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.433100, -12.649800)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(5.000431, 5.999911)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000431, -5.999911)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarChart);
export default __webpack_public_path__ + "static/media/radarChart.b88854dde60c08c0dc4f23b334253c39.svg";
export { ForwardRef as ReactComponent };